/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getTrimesters } from 'app/entities/trimester/trimester.reducer';
import { getEntities as getLabPrescriptions } from 'app/entities/lab-prescription/lab-prescription.reducer';
import { getEntities as getVitals } from 'app/entities/vitals/vitals.reducer';
import { getEntities as getAppointments } from 'app/entities/appointments/appointments.reducer';
import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getPregnancyCases } from 'app/entities/pregnancy-case/pregnancy-case.reducer';
import { createEntity, getEntity, reset, updateEntity } from './trimester-observation.reducer';

export const TrimesterObservationUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const trimesters = useAppSelector(state => state.trimester.entities);
  const labPrescriptions = useAppSelector(state => state.labPrescription.entities);
  const vitals = useAppSelector(state => state.vitals.entities);
  const appointments = useAppSelector(state => state.appointments.entities);
  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const pregnancyCases = useAppSelector(state => state.pregnancyCase.entities);
  const trimesterObservationEntity = useAppSelector(state => state.trimesterObservation.entity);
  const loading = useAppSelector(state => state.trimesterObservation.loading);
  const updating = useAppSelector(state => state.trimesterObservation.updating);
  const updateSuccess = useAppSelector(state => state.trimesterObservation.updateSuccess);

  const handleClose = () => {
    navigate(`/trimester-observation${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getTrimesters({}));
    dispatch(getLabPrescriptions({}));
    dispatch(getVitals({}));
    dispatch(getAppointments({}));
    dispatch(getGlucoUsers({}));
    dispatch(getPregnancyCases({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...trimesterObservationEntity,
      ...values,
      trimester: trimesters.find(it => it.id.toString() === values.trimester?.toString()),
      labPrescription: labPrescriptions.find(it => it.id.toString() === values.labPrescription?.toString()),
      vitals: vitals.find(it => it.id.toString() === values.vitals?.toString()),
      appointment: appointments.find(it => it.id.toString() === values.appointment?.toString()),
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
      pregnancy: pregnancyCases.find(it => it.id.toString() === values.pregnancy?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...trimesterObservationEntity,
          trimester: trimesterObservationEntity?.trimester?.id,
          labPrescription: trimesterObservationEntity?.labPrescription?.id,
          vitals: trimesterObservationEntity?.vitals?.id,
          appointment: trimesterObservationEntity?.appointment?.id,
          patient: trimesterObservationEntity?.patient?.id,
          pregnancy: trimesterObservationEntity?.pregnancy?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.trimesterObservation.home.createOrEditLabel" data-cy="TrimesterObservationCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.trimesterObservation.home.createOrEditLabel">
              Create or edit a TrimesterObservation
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="trimester-observation-id"
                  label={translate('tinyMedicRestApp.trimesterObservation.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.trimesterObservation.active')}
                id="trimester-observation-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.trimesterObservation.draft')}
                id="trimester-observation-draft"
                name="draft"
                data-cy="draft"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.trimesterObservation.cursor')}
                id="trimester-observation-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.trimesterObservation.lastUpdated')}
                id="trimester-observation-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.trimesterObservation.microSec')}
                id="trimester-observation-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.trimesterObservation.timestampEntry')}
                id="trimester-observation-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                id="trimester-observation-trimester"
                name="trimester"
                data-cy="trimester"
                label={translate('tinyMedicRestApp.trimesterObservation.trimester')}
                type="select"
              >
                <option value="" key="0" />
                {trimesters
                  ? trimesters.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="trimester-observation-labPrescription"
                name="labPrescription"
                data-cy="labPrescription"
                label={translate('tinyMedicRestApp.trimesterObservation.labPrescription')}
                type="select"
              >
                <option value="" key="0" />
                {labPrescriptions
                  ? labPrescriptions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="trimester-observation-vitals"
                name="vitals"
                data-cy="vitals"
                label={translate('tinyMedicRestApp.trimesterObservation.vitals')}
                type="select"
              >
                <option value="" key="0" />
                {vitals
                  ? vitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="trimester-observation-appointment"
                name="appointment"
                data-cy="appointment"
                label={translate('tinyMedicRestApp.trimesterObservation.appointment')}
                type="select"
              >
                <option value="" key="0" />
                {appointments
                  ? appointments.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="trimester-observation-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.trimesterObservation.patient')}
                type="select"
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="trimester-observation-pregnancy"
                name="pregnancy"
                data-cy="pregnancy"
                label={translate('tinyMedicRestApp.trimesterObservation.pregnancy')}
                type="select"
              >
                <option value="" key="0" />
                {pregnancyCases
                  ? pregnancyCases.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/trimester-observation" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TrimesterObservationUpdate;
